const initialState = {
  openingHours: {},
  loading: false
};

export function fetchOpeningHours(state = initialState, action) {
  switch (action.type) {
    case 'FETCH_OPENING_HOURS.SUCCESS':
      return {
        ...state,
        openingHours: action.openingHours.body
      };
    default:
      return state
  }
}

export function saveOpeningHours(state = initialState, action) {
  switch (action.type) {
    case 'SAVE_OPENING_HOURS.SUCCESS':
      return {
        ...state,
        openingHours: action.openingHours.body,
      };
    default:
      return state
  }
}
